<template>
    <div style="display:flex;justify-content: center; align-items: center; height: 91vh;">
    <Transition v-if="isLoading" name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>PROTO</span>
            </span>
        </div>
    </Transition>

        <v-form name="formSetting"
                class="shadow-box border border-gray-100 bg-white rounded-md shadow-md"
                style="border:1px solid #e0e0e0; padding:10px; width:60%">
            <Tabs value="0"
                  scrollable>

                <TabList>
                    <Tab value="0">{{ __('Report selection') }}</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel value="0">
                        <div class="grid">
                            <FormSelect fieldName="report_id"
                                        label="Select report"
                                        showClear
                                        :filtering="false"
                                        :isFormDisabled="false"
                                        :options="select?.reports"
                                        v-model:field="report.report_id" />
                        </div>
                        <div class="grid">
                            <FormInputToggleButton fieldName="is_send_via_email"
                                                   label="Send report by email?"
                                                   size="2"
                                                   :isFormDisabled="false"
                                                   v-model:field="report.is_send_via_email" />
                            <FormInputText v-if="report.is_send_via_email"
                                           fieldName="emails"
                                           label="Email addresses (separated by comma)"
                                           size="10"
                                           :validation="['email']"
                                           :isFormDisabled="false"
                                           v-model:field="report.emails" />

                            <FormSelect fieldName="format"
                                        label="Data format"
                                        showClear
                                        default="xlsx"
                                        size="2"
                                        :filtering="false"
                                        :isFormDisabled="false"
                                        :options="select?.reportformats"
                                        v-model:field="report.format" />
                        </div>
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <div style="margin-top:20px;text-align:right;width:200px">
                <hr style="margin-bottom:20px">
                <div class="grid">
                    <Button :label="__('Next')"
                            icon="pi pi-check"
                            class="p-button-success"
                            style="margin:10px 5px;"
                            @click="buildConditions"></Button>
                    <Button :label="__('Cancel')"
                            icon="pi pi-times"
                            class="p-button-secondary"
                            style="margin:10px 5px;"
                            @click="cancelOperation">
                    </Button>
                </div>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormSelect from "@crud/FormSelect.vue";
import FormInputToggleButton from "@crud/FormInputToggleButton.vue";
import FormInputText from "@crud/FormInputText.vue";
import Button from 'primevue/button';
import { router } from '@inertiajs/vue3';
import { __, makeReport } from '@pages/Helper/utils.js'
import { prepareSelect } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------

const props = defineProps({
    data: Object,
})

const isLoading = ref(true);
const options = ["reports", "reportformats"];
const select = ref(null);

const report = ref(props.data)

// -----------------------------------------------------

onBeforeMount(async () => {
    isLoading.value = true;
    select.value = await prepareSelect(options, null, report)
    report.value.format = 'xlsx';
    isLoading.value = false;
});

// -----------------------------------------------------

const buildConditions = async () => {
    let isConditions = true;
    select.value.reports.forEach((item) => {
        if (item?.value == report.value.report_id) {
            isConditions = item?.is_conditions
        }
    })

    if (!isConditions) {
        makeReport(props.data)
        return;
    }

    router.post(route('report-conditions'), { ...report.value })
}

// -----------------------------------------------------

const cancelOperation = () => {
    router.get(route('system-start'));
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
